import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'gatsby';
import {
  StyledHtmlDiv,
  // StyledHtmlMobileDiv,
} from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
// import SystemHeaderCard from '../systemHeaderCard/SystemHeaderCard';
import CompareTextSection from '../compareTextSection/CompareTextSection';
import CompareListSection from '../compareListSection/CompareListSection';
import CompareSection from '../compareSection/CompareSection';
import CompareSectionReviews from '../compareSection/compareSectionReviews/CompareSectionReviews';
import StarRating from '../../../molecules/shared/starRating/StarRating';
import CompareSystemLinks from '../compareSystemLink/CompareSystemLinks';
import CompareHeaderSection from '../compareHeaderSection/compareHeaderSection';
// import InfoPopup from '../../../molecules/shared/infoPopup/InfoPopup';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import CompareRenderOptionsValue from '../compareSection/compareRenderOptionsValue/CompareRenderOptionsValue';
import { CompareArrows } from '../../../../../static/icons/compareArrows';
import { Open } from '../../../../../static/icons/open';
import { Checked } from '../../../../../static/icons/checked';
import { PlusCircleIcon } from '../../../../../static/icons/iconPlusCircle';
import { getColorClass } from '../../../../utils/utils';
import { Tooltip } from '../../../atoms/tooltip/Tooltip';
import { Media } from '../../system/media/Media';

const renderOptionValue = (value, t) => {
  switch (value) {
    case 'YES':
      return (
        <>
          {/* <div className="lg:hidden flex">
            <Checked iconSize={50} />
          </div>
          <div className="hidden lg:flex">
            <Checked />
          </div> */}
          <div className="flex">
            <Tooltip description={t('compare.included')} direction="left">
              <Checked iconSize={25} />
            </Tooltip>
          </div>
        </>
      );

    case 'NO':
      return (
        <>
          {/* <div className="lg:hidden flex">
            <div className="w-[50px] h-[50px] rounded-full border-2 border-customGray-300" />
          </div>
          <div className="hidden lg:flex">
            <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
          </div> */}
          <div className="flex">
            <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
          </div>
        </>
      );

    case 'ADD':
      return (
        <>
          {/* <div className="lg:hidden flex">
            <PlusCircleIcon color="#FEC84B" iconSize={50} />
          </div>
          <div className="hidden lg:flex">
            <PlusCircleIcon color="#FEC84B" iconSize={27} />
          </div> */}
          <div className="flex">
            <Tooltip description={t('compare.canBeAdded')} direction="left">
              <PlusCircleIcon color="#FEC84B" iconSize={25} />
            </Tooltip>
          </div>
        </>
      );
    default:
      return <CompareRenderOptionsValue title={value} />;
    // return (
    //   <div className="flex">
    //     <Checked />
    //   </div>
    // );
    /*
        <Typography
          title={value}
          className="lg:line-clamp-2 lg:self-center lg:h-fit max-lg:max-w-40"
        >
          {value?.length > 31 ? value?.substring(0, 29) + '...' : value}
          {value.length > 29   && (
            <InfoPopup
              className={'!min-w-[200px]'}
              description={value}
              displayDirection={'right'}
            />
          )}
        </Typography>
      );
      */
  }
};

export const CompareList = ({ sections, t, handleDataLayer }) => {
  const platformRef = useRef(null);
  const priceRef = useRef(null);
  const companySizesRef = useRef(null);
  const functionsRef = useRef(null);
  const answersAvailableRef = useRef(null);
  const reviewsAvailableRef = useRef(null);

  const [shorcutPressed, setIsShortcutPressed] = useState(false);

  const yOffset = -315;
  /*
  useEffect(() => {
    const handleScroll = () => {
      const stickyElements = document.getElementsByClassName('sticky');

      for (let i = 0; i < stickyElements.length; i++) {
        // If the element is sticky
        const stickyElement = stickyElements[i];
        // console.log(stickyElement);
        const stickyElementTop = stickyElement.getBoundingClientRect().top;
        // console.log(stickyElementTop);
        if (stickyElementTop <= Math.abs(yOffset)) {
          stickyElement.classList.add('bg-primary-50');
          stickyElement.classList.remove('bg-primary-50');
        } else {
          stickyElement.classList.remove('bg-primary-50');
          stickyElement.classList.add('bg-primary-50');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    }, []);
  */

  const hashScrollHandler = (hash) => {
    let targetPosition = 0;

    switch (hash) {
      case '#platforms':
        targetPosition =
          platformRef.current.getBoundingClientRect().top + yOffset;
        break;
      case '#prices':
        targetPosition = priceRef.current.getBoundingClientRect().top + yOffset;
        break;
      case '#companySizes':
        targetPosition =
          companySizesRef.current.getBoundingClientRect().top + yOffset;
        break;
      case '#functions':
        targetPosition =
          functionsRef?.current?.getBoundingClientRect().top + yOffset + 50;
        break;
      case '#answersAvailable':
        targetPosition =
          answersAvailableRef?.current?.getBoundingClientRect().top +
          yOffset +
          50;
        break;
      case '#reviewsAvailable':
        targetPosition =
          reviewsAvailableRef?.current?.getBoundingClientRect().top + yOffset;
        break;
      default:
    }

    if (targetPosition !== 0) {
      window.scrollTo({
        top: targetPosition + window.scrollY,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (window.location.hash && window.location.hash.length > 0) {
        hashScrollHandler(window.location.hash);
      }
    }, 300);
    return () => {
      clearTimeout(timeout);
    };
  }, [shorcutPressed]);

  const handleMobileStickyHeaderScroll = () => {
    const mobileNonStickyHeader = document.getElementById(
      'mobileNonStickyHeader'
    );
    const mobileStickyHeader = document.getElementById('mobileStickyHeader');

    const mobileHeaderTarget = document.getElementById('mobileHeaderTarget');

    if (mobileNonStickyHeader && mobileStickyHeader && mobileHeaderTarget) {
      // hide mobileNonStickyHeader and show mobileStickyHeader when scroll to the right
      if (mobileHeaderTarget.getBoundingClientRect().left < 120) {
        mobileNonStickyHeader.classList.add('hidden');
        mobileStickyHeader.classList.remove('hidden');
      } else {
        mobileNonStickyHeader.classList.remove('hidden');
        mobileStickyHeader.classList.add('hidden');
      }
    }
  };

  const general = sections.find((el) => el.type === 'general');
  const systems = sections.find((el) => el.type === 'systems').componentData;
  const { companySizes, platforms, reviews, functions, prices, questions } =
    general.componentData;

  const prosAvailable = systems.some((el) => el.pros && el.pros.length > 0);
  const consAvailable = systems.some((el) => el.cons && el.cons.length > 0);
  const pitchVideoAvailable = systems.some((el) => el.pitchVideos?.length > 0);
  const reviewsAvailable = systems.some(
    (system) => system.averageRatings?.length > 0
  );
  const answersAvailable = systems.some(
    (el) =>
      el.answers &&
      el.answers.length > 0 &&
      el.answers.filter((ans) => ans?.text?.length > 1)?.length > 0
  );
  const functionsAvailable = systems.some(
    (el) => el.functions && el.functions.length > 0
  );

  const offsetSubTitle = '255px';

  return (
    <div className="flex w-full flex-col flex-1 px-2 sm:px-8 mx-auto max-w-7xl my-5 my-15 gap-2 sm:gap-10 gap-x-0">
      <div
        className="flex flex-col gap-10 relative"
        onScroll={handleMobileStickyHeaderScroll}
      >
        {/* Mobile */}
        {/* <div
          className="flex flex-1 justify-between lg:mb-5 flex-col lg:flex-row gap-5 lg:hidden left-0 z-40 "
          id="mobileNonStickyHeader"
        >
          <div className="flex flex-col h-12 justify-end" />
          <div className="flex h-3 flex-row justify-center items-center px-5 gap-1" />
          {systems.map((system, i) => (
            <div
              key={`big-${i}`}
              className="flex flex-1 flex-col min-w-52 max-w-52"
            >
              <SystemHeaderCard
                system={system}
                getColorClass={() => getColorClass(i)}
                tiny={false}
                t={t}
              />
            </div>
          ))}
        </div> */}

        {/* <div
          className="hidden flex flex-1 justify-between lg:mb-5 flex-col lg:flex-row gap-5 lg:hidden left-0 sticky z-30"
          id="mobileStickyHeader"
        >
          <div className="flex flex-col h-12 justify-end" />
          <div className="flex h-3 flex-row justify-center items-center px-5 gap-1" />
          {systems.map((system, i) => (
            <div
              key={`small-${i}`}
              className="flex flex-1 flex-col min-w-52 max-w-52"
            >
              <SystemHeaderCard
                system={system}
                getColorClass={() => getColorClass(i)}
                tiny
                t={t}
              />
            </div>
          ))}
        </div> */}

        {/* Desktop */}
        <div className="flex flex-1 flex-col sticky top-[100px] z-40">
          <div className="flex flex-col">
            <div className="flex flex-row max-h-32 justify-between gap-1 sm:gap-5">
              <div className="hidden lg:flex flex-1 flex-col overflow-visible">
                <div className="flex flex-1 flex-col gap-1">
                  <div className="flex flex-row-reverse">
                    <div className={`${getColorClass(0)} rounded-xl shadow-md`}>
                      <div className="p-5 w-full break-words">
                        <Stack className="divide-y divide-customGray-200">
                          <Row className="pb-2 justify-between">
                            <Typography fontVariant="h5">
                              {t('systemCard.compare')}
                            </Typography>
                            <CompareArrows />
                          </Row>
                          <Row className="py-2">
                            <Link
                              onClick={() => {
                                setIsShortcutPressed(!shorcutPressed);
                              }}
                              to="#companySizes"
                            >
                              <Typography
                                fontVariant="h7"
                                textAlign="left"
                                title={companySizes?.title}
                              >
                                {companySizes?.title}
                              </Typography>
                            </Link>
                          </Row>
                          <Row className="py-2">
                            <Link
                              onClick={() => {
                                setIsShortcutPressed(!shorcutPressed);
                              }}
                              to="#platforms"
                            >
                              <Typography
                                fontVariant="h7"
                                textAlign="left"
                                title={platforms?.title}
                              >
                                {platforms?.title}
                              </Typography>
                            </Link>
                          </Row>
                          <Row className="py-2">
                            <Link
                              onClick={() => {
                                setIsShortcutPressed(!shorcutPressed);
                              }}
                              to="#prices"
                            >
                              <Typography
                                fontVariant="h7"
                                textAlign="left"
                                title={prices?.title}
                              >
                                {prices?.title}
                              </Typography>
                            </Link>
                          </Row>

                          {functionsAvailable && (
                            <Row className="py-2 break-words">
                              <Link
                                onClick={() => {
                                  setIsShortcutPressed(!shorcutPressed);
                                }}
                                to="#functions"
                              >
                                <Typography
                                  fontVariant="h7"
                                  textAlign="left"
                                  title={t('catFilter.productFunctions')}
                                >
                                  {t('catFilter.productFunctions')}
                                </Typography>
                              </Link>
                            </Row>
                          )}

                          {answersAvailable && (
                            <Row className="py-2">
                              <Link
                                onClick={() => {
                                  setIsShortcutPressed(!shorcutPressed);
                                }}
                                to="#answersAvailable"
                              >
                                <Typography
                                  fontVariant="h7"
                                  textAlign="left"
                                  title={questions?.title}
                                >
                                  {questions?.title}
                                </Typography>
                              </Link>
                            </Row>
                          )}
                          {reviewsAvailable && (
                            <Row className="py-2">
                              <Link
                                onClick={() => {
                                  setIsShortcutPressed(!shorcutPressed);
                                }}
                                to="#reviewsAvailable"
                              >
                                <Typography
                                  fontVariant="h7"
                                  textAlign="left"
                                  title={reviews?.title}
                                >
                                  {reviews?.title}
                                </Typography>
                              </Link>
                            </Row>
                          )}
                          {/* prosAvailable && (
                            <>
                              <Row className="py-2">
                                <Link to="#prosAvailable">{t('sp.pros')}</Link>
                              </Row>
                            </>
                          )}
                          {consAvailable && (
                            <>
                              <Row className="py-2">
                                <Link to="#consAvailable">{t('sp.cons')}</Link>
                              </Row>
                            </>
                          ) */}
                        </Stack>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Each System */}
              {systems.map((system) => (
                <div
                  key={`system-${system.id}`}
                  className={`flex flex-1 flex-col p-1 sm:p-5 sm:pt-8 justify-end max-h-32 gap-1 rounded-xl shadow-md ${getColorClass(
                    0
                  )}`}
                >
                  <Stack className="flex-1">
                    <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4 py-2">
                      <div className="flex flex-row w-full sm:w-auto items-center gap-4">
                        <img
                          src={system.logoUrl}
                          alt={system.name}
                          width={60}
                          height={60}
                          loading="lazy"
                          className="hidden sm:flex"
                        />
                        <Stack className="flex-1 h-full items-start justify-center gap-1 max-h-20">
                          <Typography
                            className="overflow-hidden line-clamp-2 leading-none"
                            textAlign="left"
                            fontVariant="h7"
                          >
                            {system.name}
                          </Typography>
                          <StarRating
                            width={12}
                            height={12}
                            fillColor="#FEC84B"
                            rating={system.ratingBW}
                          />
                        </Stack>
                      </div>
                      <LinkButton
                        trackingFn={system.trackingFn ?? null}
                        size="md"
                        textTransform="uppercase"
                        // label={t('systemCard.readMore')}
                        href={system.readMoreHref}
                        className="gap-1 w-fit text-clamp-button p-2 sm:px-6 sm:py-3 uppercase select-none !text-white"
                      >
                        {system.trackingFn ? (
                          <>
                            {t('systemCard.website')} <Open size={16} />
                          </>
                        ) : (
                          t('systemCard.readMore')
                        )}
                      </LinkButton>
                    </div>
                  </Stack>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="flex lg:flex-1 flex-col relative"
          id="mobileHeaderTarget"
        >
          <CompareHeaderSection
            title={companySizes.title}
            subTitle={companySizes.subTitle}
            className={`sticky top-0 top-[${offsetSubTitle}]`}
            id="companySizesId"
          />
          <CompareSection
            ref={companySizesRef}
            key="companySizesCompareSection"
            title={companySizes.title}
            items={companySizes.items}
            systems={systems}
            first
            renderValue={(system, item) =>
              system.companySizes.includes(item.value) ? (
                <>
                  {/* <div className="lg:hidden flex">
                    <Checked iconSize={50} />
                  </div>
                  <div className="hidden lg:flex">
                    <Checked />
                  </div> */}
                  <div className="flex">
                    <Checked iconSize={25} />
                  </div>
                </>
              ) : (
                <>
                  {/* <div className="lg:hidden flex">
                    <div className="w-[50px] h-[50px] rounded-full border-2 border-customGray-300" />
                  </div>
                  <div className="hidden lg:flex">
                    <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
                  </div> */}
                  <div className="flex">
                    <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
                  </div>
                </>
              )
            }
          />
        </div>
        <div className="flex flex-1 flex-col relative">
          <CompareHeaderSection
            title={platforms.title}
            className={`sticky top-0 top-[${offsetSubTitle}]`}
          />
          <CompareSection
            ref={platformRef}
            key="platformsCompareSection"
            title={platforms.title}
            items={platforms.items}
            systems={systems}
            shouldRenderValue={(system, item) =>
              system.platforms.includes(item.value)
            }
            renderValue={(system, item) =>
              system.platforms.includes(item.value) ? (
                <>
                  {/* <div className="lg:hidden flex">
                    <Checked iconSize={50} />
                  </div>
                  <div className="hidden lg:flex">
                    <Checked />
                  </div> */}
                  <div className="flex">
                    <Checked iconSize={25} />
                  </div>
                </>
              ) : (
                <>
                  {/* <div className="lg:hidden flex">
                    <div className="w-[50px] h-[50px] rounded-full border-2 border-customGray-300" />
                  </div>
                  <div className="hidden lg:flex">
                    <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
                  </div> */}
                  <div className="flex">
                    <div className="w-[25px] h-[25px] rounded-full border-2 border-customGray-300" />
                  </div>
                </>
              )
            }
          />
        </div>
        <div className="flex lg:flex-1 flex-col relative">
          <CompareHeaderSection
            title={prices.title}
            className={`sticky top-0 top-[${offsetSubTitle}]`}
          />
          <CompareSection
            ref={priceRef}
            key="pricesCompareSection"
            title={prices.title}
            items={prices.items}
            systems={systems}
            renderValue={(system, item) => {
              const price = system.prices.find(
                (price) => price.title === item.title
              );
              return renderOptionValue(price ? price.value : 'NO', t);
            }}
          />
        </div>

        {functionsAvailable &&
          functions.map((func, funcIndex) => (
            <div key={func.key} className="flex flex-1 flex-col relative">
              {funcIndex === 0 && (
                <CompareHeaderSection
                  title={func.title}
                  className={`sticky top-0 top-[${offsetSubTitle}]`}
                  ref={functionsRef}
                />
              )}
              {funcIndex !== 0 && (
                <CompareHeaderSection
                  title={func.title}
                  className={`sticky top-0 top-[${offsetSubTitle}]`}
                />
              )}
              <CompareSection
                title={func.title}
                items={func.items}
                systems={systems}
                renderValue={(system, item) => {
                  const items = system.functions?.find(
                    (e) => e.key === func.key
                  )?.items;
                  const functionItem = items?.find((e) => e.key === item.key);
                  return renderOptionValue(
                    functionItem ? functionItem.value : null,
                    t
                  );
                }}
              />
            </div>
          ))}

        {answersAvailable && (
          <div className="flex flex-1 flex-col relative">
            <CompareHeaderSection
              title={questions.title}
              className={`sticky top-0 top-[${offsetSubTitle}]`}
              ref={answersAvailableRef}
            />
            <CompareTextSection
              title={questions.title}
              items={questions.items}
              systems={systems}
              renderValue={(system, item) => {
                const el = system.answers?.find(
                  (e) => e.question_id === item.id
                );
                return (
                  <>
                    {/* <div className="hidden lg:flex flex-row gap-0">
                      <StyledHtmlDiv
                        className="normal-case text-left"
                        content={el?.text ? el.text : t('common.noData')}
                      />
                    </div>
                    <div className="lg:hidden sm:flex flex-row gap-0 overflow-scroll">
                      <StyledHtmlMobileDiv
                        className="normal-case text-left"
                        content={el?.text ? el.text : t('common.noData')}
                      />
                    </div> */}
                    <div className="flex flex-row gap-0">
                      <StyledHtmlDiv
                        className="text-xs sm:text-clamp-md break-words sm:break-normal normal-case text-left"
                        content={el?.text ? el.text : t('common.noData')}
                      />
                    </div>
                  </>
                );
              }}
            />
          </div>
        )}

        {reviewsAvailable && (
          <div className="flex flex-1 flex-col relative">
            <CompareHeaderSection
              title={reviews.title}
              className={`sticky top-0 top-[${offsetSubTitle}]`}
              ref={reviewsAvailableRef}
            />
            <CompareSectionReviews
              subtitle={reviews.subtitle}
              items={reviews.items}
              systems={systems}
              t={t}
              renderValue={(ratingItem) => (
                <>
                  <div className="text-xs sm:text-base w-full lg:w-auto place-content-start">
                    {ratingItem.title}
                  </div>
                  <StarRating
                    rating={ratingItem.value}
                    className="w-20 sm:w-full lg:w-auto grow place-content-end"
                    width={20}
                    height={20}
                  />
                </>
              )}
            />
          </div>
        )}

        {prosAvailable && (
          <div className="flex flex-1 flex-col relative">
            <CompareHeaderSection
              label={reviews.title}
              title={t('sp.pros')}
              className={`sticky top-0 top-[${offsetSubTitle}] pt-0 lg:pt-0`}
            />
            <CompareListSection
              title={t('sp.pros')}
              systems={systems}
              renderValue={(system) =>
                system.pros?.length ? (
                  system.pros?.map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-row items-center before:content-['+'] before:inline-block before:text-2xl before:pr-4 before:self-center before:leading-none"
                    >
                      <StyledHtmlDiv
                        className="text-xs sm:text-clamp-md break-words sm:break-normal normal-case text-left py-1"
                        content={item && item?.trim() !== '' ? item : null}
                      />
                    </div>
                  ))
                ) : (
                  <Typography
                    textAlign="left"
                    className="italic !text-customGray-700"
                    fontVariant="sm"
                  >
                    {t('common.noData')}
                  </Typography>
                )
              }
            />
          </div>
        )}

        {consAvailable && (
          <div className="flex flex-1 flex-col relative">
            <CompareHeaderSection
              label={reviews.title}
              title={t('sp.cons')}
              className={`sticky top-0 top-[${offsetSubTitle}] pt-0 lg:pt-0`}
            />
            <CompareListSection
              title={t('sp.cons')}
              systems={systems}
              renderValue={(system) =>
                system.cons?.length ? (
                  system.cons?.map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-row items-center before:content-['-'] before:inline-block before:text-2xl before:pr-5 before:self-center before:leading-none"
                    >
                      <StyledHtmlDiv
                        className="text-xs sm:text-clamp-md break-words sm:break-normal normal-case text-left py-1"
                        content={item && item?.trim() !== '' ? item : null}
                      />
                    </div>
                  ))
                ) : (
                  <Typography
                    textAlign="left"
                    className="italic !text-customGray-700"
                    fontVariant="sm"
                  >
                    {t('common.noData')}
                  </Typography>
                )
              }
            />
          </div>
        )}

        {pitchVideoAvailable && (
          <div className="flex flex-1 flex-col relative">
            <CompareHeaderSection
              title=""
              className={`sticky top-0 top-[${offsetSubTitle}]`}
            />
            <CompareListSection
              title=""
              systems={systems}
              renderValue={(system) => {
                if (system.pitchVideos?.length >= 1) {
                  return (
                    <Media
                      category={system.category}
                      media={system.pitchVideos}
                      systemName={system.name}
                      handleDataLayer={handleDataLayer}
                    />
                  );
                }

                return (
                  <Typography
                    textAlign="left"
                    className="italic !text-customGray-700"
                    fontVariant="sm"
                  >
                    {t('common.noData')}
                  </Typography>
                );
              }}
            />
          </div>
        )}

        <CompareSystemLinks
          systems={systems}
          getColorClass={(i) => getColorClass(i)}
          t={t}
        />
      </div>
    </div>
  );
};
